import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './i18n';

// ReactQuill yazı seçimi sorunu için
document.addEventListener('DOMContentLoaded', () => {
  // Yazı seçim sorununu düzeltmek için global stil ekleme
  const fixQuillSelectionStyle = document.createElement('style');
  fixQuillSelectionStyle.innerHTML = `
    .ql-editor p, .ql-editor h1, .ql-editor h2, .ql-editor h3, 
    .ql-editor h4, .ql-editor h5, .ql-editor h6, .ql-editor ul, 
    .ql-editor ol, .ql-editor li, .ql-editor blockquote {
      user-select: text !important;
      -webkit-user-select: text !important;
      -moz-user-select: text !important;
      cursor: text !important;
    }
  `;
  document.head.appendChild(fixQuillSelectionStyle);

  // ReactQuill editörlerde tıklama işlevi
  document.addEventListener('click', (e) => {
    const target = e.target as HTMLElement;
    if (target.closest('.react-quill-wrapper')) {
      const editor = target.closest('.react-quill-wrapper')?.querySelector('.ql-editor');
      if (editor && editor instanceof HTMLElement) {
        editor.focus();
      }
    }
  });
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
